@if (pkg$ | async; as pkg) {
  <div class="layout-col full bg-background">
    <app-package-detail class="flex" [package]="pkg" [company]="company" (close)="close()">
    </app-package-detail>
  </div>
}
